import React from "react";

const About = (props) => {
  return (
    <div className="aboutCard">
      <div className="sectionIntro sectionIntro--left">
        {/* <span className="sectionIntro__eyebrow">About</span> */}
        <h2 className="sectionIntro__title">{props.site.aboutUsPageTitle}</h2>
        <p className="sectionIntro__text">{props.site.aboutUsDescription}</p>
      </div>
    </div>
  );
};

export default About;
